import { StoreState } from '../store-interfaces';
import { createSelector } from 'reselect';
import { combinedFeatureFlagsSelector } from './featureFlagsSelectors';

export const selectAdAccounts = (state: StoreState) =>
  state.adAccounts.entities || [];

export const selectActiveAdAccount = createSelector(
  [selectAdAccounts],
  adAccounts => adAccounts.find(ac => !!ac.selected),
);

export const canUseFacebookAdsSyncIntegrationAndWidget = createSelector(
  [combinedFeatureFlagsSelector],
  features => true, // !!features['ads_audiences_email'],
);
